/**
 * 账号唯一模式的幂等清理器。
 * 匿名业务数据不迁移、不恢复；只保留设备设置和登录状态。
 */
import { DATA_MODULES, LEGACY_KEY_MAP } from "./data-registry";

const CLEANUP_MARKER = "battlecode-anonymous-cleanup-v1";
const DEVICE_KEYS = new Set([
  "battlecode-llm-api-key",
  "battlecode-llm-daily-count",
  "battlecode-llm-daily-date",
  "battlecode-editor",
  "battlecode-theme",
  "battlecode-locale",
]);

export async function purgeAnonymousStorage(): Promise<void> {
  purgeAnonymousLocalStorage();
  await purgeAnonymousOpfs();
  localStorage.setItem(CLEANUP_MARKER, new Date().toISOString());
}

function purgeAnonymousLocalStorage(): void {
  const keysToRemove = new Set<string>(Object.keys(LEGACY_KEY_MAP));
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key || !key.startsWith("battlecode-")) continue;
    if (DEVICE_KEYS.has(key)) continue;
    if (key === "battlecode-auth-token" || key === "battlecode-user-profile" || key === "battlecode-current-user") continue;
    if (key === CLEANUP_MARKER) continue;
    if (DATA_MODULES.some((module) => key === `battlecode-${module}`)) keysToRemove.add(key);
  }
  for (const key of keysToRemove) localStorage.removeItem(key);
}

async function purgeAnonymousOpfs(): Promise<void> {
  if (typeof navigator === "undefined" || typeof navigator.storage?.getDirectory !== "function") return;
  try {
    const root = await navigator.storage.getDirectory();
    await removeIfPresent(root, "levels");
    const users = await root.getDirectoryHandle("users");
    for await (const [name, handle] of (users as any).entries()) {
      if (handle.kind === "directory" && name.startsWith("anonymous-")) {
        await users.removeEntry(name, { recursive: true });
      }
    }
  } catch (error) {
    console.warn("[anonymous-cleanup] OPFS cleanup deferred:", error);
  }
}

async function removeIfPresent(root: FileSystemDirectoryHandle, name: string): Promise<void> {
  try {
    await root.removeEntry(name, { recursive: true });
  } catch (error) {
    if (error instanceof DOMException && error.name === "NotFoundError") return;
    throw error;
  }
}
